<template>
  <div>
    <card class="w-100">
      <el-row :gutter="10">
        <form @submit.prevent="changePage">
          <el-col :span="6">
            <div class="form-group">
              <label>매체구분</label>
              <el-select v-model="searchMediaType" @change="changePage">
                <el-option
                  key=""
                  value=""
                  label="전체"></el-option>
                <el-option
                  key="WC"
                  value="WC"
                  label="와이드칼라"></el-option>
                <el-option
                  key="DM"
                  value="DM"
                  label="디지털미디어"></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label>매체명</label>
              <el-input v-model="searchName" placeholder="매체명">
              </el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
            </div>
          </el-col>
          <el-col :span="2">
            <div class="form-group">
            </div>
          </el-col>
          <el-col :span="4">
            <div class="pull-right-top24">
              <el-button type="primary" native-type="submit" icon="el-icon-search">검색</el-button>
              <el-button type="primary" @click="resetPage" icon="el-icon-refresh">초기화</el-button>
            </div>
          </el-col>
        </form>
      </el-row>
    </card>
    <card class="w-100">
      <el-col :span="24">
        <el-table class="table-striped"
                  border
                  style="width: 100%; margin-bottom: 10px"
                  ref="mediaTable"
                  :data="$store.state.media.mediaInfos"
                  :header-cell-style="tableRowStyle">
          <el-table-column
            label="매체구분"
            prop="mediaType"
            sortable
            width="130">
            <template slot-scope="props">
              {{ getMediaType(props.row.mediaType) }}
            </template>
          </el-table-column>
          <el-table-column
            label="색상"
            width="75"
            align="center">
            <template slot-scope="props">
              <el-button :style="'background-color:' +  props.row.color" circle></el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="mediaName"
            sortable
            label="매체명">
          </el-table-column>
          <el-table-column
            label="등록일"
            prop="regDate"
            sortable
            width="120">
            <template slot-scope="props">
              {{ props.row.regDate | moment('YYYY-MM-DD')}}
            </template>
          </el-table-column>
          <el-table-column
            sortable
            prop="width"
            label="넓이">
            <template slot-scope="props">
              {{ props.row.width | numeral('0,0')}} mm
            </template>
          </el-table-column>
          <el-table-column
            sortable
            prop="height"
            label="높이">
            <template slot-scope="props">
              {{ props.row.height | numeral('0,0')}} mm
            </template>
          </el-table-column>
          <el-table-column
            prop="isLight"
            label="조명여부/송출시간"
            sortable
            width="100">
            <template slot-scope="props">
              {{ props.row.mediaType === "DM" ? props.row.duration + "초" : ""}}
              {{ props.row.mediaType === "WC" ? getIsLight(props.row.isLight) : ""}}
            </template>
          </el-table-column>
          <!--<el-table-column
            prop="inOut"
            label="IN/OUT"
            sortable
            width="110">
          </el-table-column>-->
          <el-table-column
            prop="mainExposure"
            label="전체현황"
            sortable
            width="110">
            <template slot-scope="props">
              {{ props.row.mainExposure ? "노출" : "비노출"}}
            </template>
          </el-table-column>
          <el-table-column
            sortable
            prop="prepaymentPrice"
            width="120"
            label="연광고료">
            <template slot-scope="props">
              {{ props.row.prepaymentPrice | numeral('0,0')}}원
            </template>
          </el-table-column>
          <el-table-column
            sortable
            prop="installmentPrice"
            width="110"
            label="월광고료">
            <template slot-scope="props">
              {{ props.row.installmentPrice | numeral('0,0')}}원
            </template>
          </el-table-column>
          <el-table-column
            prop="orderNum"
            label="정렬순서"
            sortable
            width="100">
          </el-table-column>
          <el-table-column
            label="관리"
            width="100">
            <template slot-scope="props">
              <el-button  icon="el-icon-edit" @click="handleEdit(props.$index, props.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24">
        <div class="pull-right">
          <el-button type="primary" icon="el-icon-plus" v-on:click="register">매체 등록</el-button>
        </div>
      </el-col>
    </card>
  </div>

</template>

<script>
    import Vue from 'vue'
    import {Table, TableColumn, Input, Button, Select, Option, Row, Col} from 'element-ui'
    import VueMoment from 'vue-moment'
    import vueNumeralFilterInstaller from 'vue-numeral-filter';

    Vue.use(vueNumeralFilterInstaller)
    Vue.use(VueMoment)
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Button)
    Vue.use(Row)
    Vue.use(Col)
    Vue.use(Input)
    Vue.use(Select)
    Vue.use(Option)

    export default {
        name: "MediaManagement",
        created: function () {
          if(this.$route.params.searchMediaType !== undefined) this.searchMediaType = this.$route.params.searchMediaType;
          if(this.$route.params.searchName !== undefined) this.searchName = this.$route.params.searchName;
            this.$store.dispatch('common/setMenuTitle', "매체 관리");
            this.changePage();
        },
        updated: function () {
            this.$refs.mediaTable.doLayout();
        },
        methods: {
            tableRowStyle() {
                return this.$store.state.common.tableHeaderCellStyle;
            },
            // 수정
            handleEdit(index, row) {
                Vue.router.push({name: 'MediaManagementEdit', params: {mediaInfoSeq : row.mediaInfoSeq, searchName: this.searchName, searchMediaType: this.searchMediaType}});
            },
            register() {
                Vue.router.push({name: 'MediaManagementRegistration'});
            },
            changePage() {
                let param = {
                    searchName: this.searchName,
                    searchMediaType: this.searchMediaType
                };
                this.$store.dispatch('media/findAll', param);
            },
            // 화면 초기화
            resetPage() {
                this.searchName = '';
                this.searchMediaType = "";
                this.changePage();
            },
            getMediaType(media_type) {
                return Vue.getMediaType(media_type);
            },
            getIsLight(isLight) {
              return Vue.getIsLight(isLight);
            },
        },
        data() {
            return {
                searchName: '',
                searchMediaType: "",
            }
        }
    }
</script>

<style scoped>

</style>
